export default __webpack_public_path__ + "static/media/703.b66f2bc2.png";